import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import NoImage from '../../assets/images/noimage.png';
import Dropzone from 'react-dropzone-uploader';
import SweetAlert from 'sweetalert2';
import { getTeams, addteams, updateteams, updateteamsImage, updatepartnerImage, deleteteams } from '../../store/teamsSlice';
import { getleadership, ModalToggle, isOpenModal, addleadership, updateleadership, isImageOpenModal, isPartnerOpenModal, updateleadershipImage, updateIconImage, isOpenStatusModal, statusToggle, deleteleadership, updateLeadershipStatus, } from '../../store/leadershipSlice';

const LeadershipTable = () => {
  const storeVar = useSelector(state => state.leader)
  const dispatch = useDispatch();
  const toggle = () => dispatch(ModalToggle());
  const Imagetoggle = () => dispatch(isImageOpenModal());
  const Partnershiptoggle = () => dispatch(isPartnerOpenModal());
  const statusModalToggle = () => dispatch(statusToggle());

  const [submit, setSubmit] = useState(false);
  const [stateStatus, setStateStatus] = useState('active');
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
    status: 'active',
    modalTitle: null,
    editState: false,
    teamId: '',
    name: '',
    post: '',
    linkedIn: '',
    description: '',
    priority: '',
    bannerFile: null,
    bannerImageURL: null,



  });

  useEffect(() => {
    dispatch(getleadership(formVar.status))
  }, []);


  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      categoryId: data.id,
      modalTitle: 'Edit Leadership',
      teamId: data._id,
      name: data.name,
      post: data.post,
      linkedIn: data.linkedIn,
      description: data.description,
      priority: data.priority,
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Leadership',
      teamId: '',
      name: '',
      post: '',
      linkedIn: '',
      description: '',
      priority: '',
    }))
  }



  const submitLeadership = () => {
    if (nameValid() || postValid() || descriptionValid() || linkedInValid() || priorityValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    if (formVar.editState) {
      dispatch(updateleadership(formVar.teamId, { name: formVar.name, post: formVar.post, priority: formVar.priority,description: formVar.description, linkedIn: formVar.linkedIn, }))
    } else {
      dispatch(addleadership({ name: formVar.name, post: formVar.post, priority: formVar.priority,description: formVar.description, linkedIn: formVar.linkedIn, }))
    }
  }


  const nameValid = () => {
    if (!formVar.name) {
      return "Name is required";
    }
  }
  const postValid = () => {
    if (!formVar.post) {
      return "Designation is required";
    }
  }
  const priorityValid = () => {
    if (!formVar.priority) {
      return "Priority is required";
    }
  }
  const linkedInValid = () => {
    if (!formVar.linkedIn) {
      return "LinkedIn id is required";
    }
  }
  const descriptionValid = () => {
    if (!formVar.description) {
      return "Description is required";
    }
  }


  const filesValid = () => {
    if (!formVar.bannerFile) {
      return "Files is required";
    }
  }
  const ImageEditBannerModal = (data) => {
    dispatch(isImageOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      id: data._id,
      modalTitle: 'Update Profile Image',
      bannerFile: null,
      bannerImageURL: null
    }))
  }
  const ImageEditPartnershipModal = (data) => {
    dispatch(isPartnerOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      id: data._id,
      modalTitle: 'Update Icon',
      bannerFile: null,
      bannerImageURL: null
    }))
  }
  const statusToggleModal = (data) => {
    console.log(data);

    dispatch(isOpenStatusModal(true))
    setStateStatus(data.status)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      teamId: data._id,
    }))
  }

  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === 'done') {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormVar((prevFormVar) => ({
          ...prevFormVar,
          bannerImageURL: e.target.result,
        }))
      };
      reader.readAsDataURL(file);
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: file,
      }))
    } else if (status === "removed") {
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: null,
        bannerImageURL: null,
      }))
    }
  };

  const submitImage = () => {
    if (filesValid()) {
      setSubmit(true)
      return null
    }

    setSubmit(false)
    dispatch(updateleadershipImage(formVar.id, formVar.bannerFile))
  }

  const submitPartnerImage = () => {
    if (filesValid()) {
      setSubmit(true)
      return null
    }

    setSubmit(false)
    dispatch(updateIconImage(formVar.id, formVar.bannerFile))
  }

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(deleteleadership(data._id,))
        }
      });
  }

  const handleInputChange = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, status: e.target.value }))
    dispatch(getleadership(e.target.value))
  };



  const submitStatus = () => {
    dispatch(updateLeadershipStatus(formVar.teamId, stateStatus))
  }

  const onValueChange = (event) => {
    setStateStatus(event.target.value)
  }


  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">

              </Col>
              <Col md="4">
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  value={formVar.status} onChange={handleInputChange}>
                  <option value='active'>ACTIVE</option>
                  <option value='pending'>PENDING</option>
                </Input>
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Leadership
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Designation</th>
                  <th scope='col'>Priority</th>
                  <th scope='col'>Profile Image</th>
                  <th scope='col'>Icon</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.leadershipData?.map((item, index) => (
                  <tr key={item._id}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.name}</td>
                    <td>{item.post}</td>
                    <td>{item.priority}</td>
                    <td className='w-20'>
                      {item.profile ? <img className='w-5-r h-5-r' src={item.profile} alt="" /> : <img className='w-10-r h-5-r' src={NoImage} alt="" />}
                    </td>
                    <td className='w-20'>
                      {item.icon ? <img className='w-10-r h-5-r' src={item.icon} alt="" /> : <img className='w-10-r h-5-r' src={NoImage} alt="" />}
                    </td>
                    <td>
                      {
                        item.status === 'active' && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>{item.status.toUpperCase()}</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'pending' && <>
                          <span className={`font-warning rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>{item.status.toUpperCase()}</span>
                          </span>
                        </>
                      }
                    </td>

                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer font-success action-icon'>
                          <i className="fa fa-picture-o fa-lg" onClick={(e) => ImageEditBannerModal(item)} />
                          <div className="tooltipCustom">Update Profile Image</div>
                        </div>
                        <div className='cursor-pointer font-info action-icon'>
                          <i className="fa fa-users fa-lg" onClick={(e) => ImageEditPartnershipModal(item)} />
                          <div className="tooltipCustom">Update Icon</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-success action-icon'>
                          <i className="fa fa-toggle-on fa-lg" onClick={(e) => statusToggleModal(item)}></i>
                          <div className="tooltipCustom">Status Update</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalleadership <= 0 && (
              <Empty />
            )
          }
        </Card>

      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} >
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Name</Label>
            <Input className="form-control" type="text" placeholder='Enter Name' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, name: e.target.value }))} value={formVar.name} />
            {submit && nameValid() ? <span className='d-block font-danger'>{nameValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">Designation</Label>
            <Input className="form-control" type="text" placeholder='Enter Designation' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, post: e.target.value }))} value={formVar.post} />
            {submit && postValid() ? <span className='d-block font-danger'>{postValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">LinkedIn</Label>
            <Input className="form-control" type="text" placeholder='Enter LinkedIn Url' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, linkedIn: e.target.value }))} value={formVar.linkedIn} />
            {submit && linkedInValid() ? <span className='d-block font-danger'>{linkedInValid()}</span> : ""}

            <Label className="col-form-label" for="recipient-name">Description</Label>
            <textarea rows={3} className="form-control" type="text" placeholder='Enter Description' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, description: e.target.value }))} value={formVar.description} />
            {submit && descriptionValid() ? <span className='d-block font-danger'>{descriptionValid()}</span> : ""}


            <Label className="col-form-label" for="recipient-name">Priority</Label>
            <Input className="form-control" type="text" placeholder='Enter Priority (1 Being Highest)' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, priority: e.target.value }))} value={formVar.priority} />
            {submit && priorityValid() ? <span className='d-block font-danger'>{priorityValid()}</span> : ""}

          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitLeadership }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

      <CommonModal isOpen={storeVar.isImageOpenModal} title={formVar.modalTitle} toggler={Imagetoggle} >
        <Form>
          <FormGroup>

            <Label className="col-form-label" for="recipient-name">Update Image</Label>
            <Dropzone
              className='dropzone dz-clickable'
              onChangeStatus={handleChangeStatus}
              maxFiles={1}
              multiple={false}
              // canCancel={false}
              accept="image/*"
              inputContent='Drop A File'
              styles={{
                dropzone: { width: '100%', height: 150 },
                dropzoneActive: { borderColor: 'green' },
              }}
            />
            {submit && filesValid() ? <span className='d-block font-danger'>{filesValid()}</span> : ""}
          </FormGroup>

        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: Imagetoggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitImage }}>Save Changes</Btn>

        </ModalFooter>
      </CommonModal>
      <CommonModal isOpen={storeVar.isPartnerOpenModal} title={formVar.modalTitle} toggler={Partnershiptoggle} >
        <Form>
          <FormGroup>

            <Label className="col-form-label" for="recipient-name">Update Image</Label>
            <Dropzone
              className='dropzone dz-clickable'
              onChangeStatus={handleChangeStatus}
              maxFiles={1}
              multiple={false}
              // canCancel={false}
              accept="image/*"
              inputContent='Drop A File'
              styles={{
                dropzone: { width: '100%', height: 150 },
                dropzoneActive: { borderColor: 'green' },
              }}
            />
            {submit && filesValid() ? <span className='d-block font-danger'>{filesValid()}</span> : ""}
          </FormGroup>

        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: Partnershiptoggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitPartnerImage }}>Save Changes</Btn>

        </ModalFooter>
      </CommonModal>
      <CommonModal isOpen={storeVar.isStatusOpenModal} title={'Status'} toggler={statusModalToggle} >
        <Col>
          <div className='d-flex m-15 m-checkbox-inline justify-content-center custom-radio-ml'>
            <div className='radio radio-primary'>
              <Input id='radioinline1' type='radio' className="radio_animated" name='radio1' checked={stateStatus === 'active'} onChange={onValueChange} value='active' />
              <Label className='mb-0' for='radioinline1'>
                <span className='digits'>ACTIVE</span>
              </Label>
            </div>
            <div className='radio radio-primary'>
              <Input id='radioinline3' type='radio' className="radio_animated" name='radio3' checked={stateStatus === 'pending'} onChange={onValueChange} value='pending' />
              <Label className='mb-0' for='radioinline3'>
                <span className='digits'>PENDING</span>
              </Label>
            </div>
          </div>
        </Col>
        <ModalFooter className='justify-content-center'>
          <Btn attrBtn={{ color: 'secondary', onClick: statusModalToggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitStatus }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

    </Fragment>
  );
};

export default LeadershipTable;
